import { Set, Map } from 'immutable';
import * as Immutable from 'immutable';
import { TutorialAction, TutorialActionTypes } from 'Types/TutorialTypes';

export interface TutorialReducerState {
  completed: Immutable.Map<number, Immutable.Set<number>>;
  lastChapter: Immutable.Map<number, number>;
  playbackSpeed: number;
  manualPause?: boolean;
}

const defaultState: TutorialReducerState = {
  completed: Map<number, Set<number>>([]),
  lastChapter: Map<number, number>([]),
  playbackSpeed: 1,
  manualPause: undefined,
};

export function tutorialReducer(
  state: TutorialReducerState = defaultState,
  action: TutorialAction,
): TutorialReducerState {
  switch (action.type) {
    case TutorialActionTypes.MARK_CHAPTER_COMPLETE: {
      return {
        ...state,
        completed: Immutable.set(
          state.completed,
          action.payload.lesson,
          Immutable.Set(Immutable.get(state.completed, action.payload.lesson) || []).union([
            action.payload.chapter,
          ]),
        ),
      };
    }
    case TutorialActionTypes.SET_LAST_CHAPTER: {
      return {
        ...state,
        lastChapter: Immutable.set(
          state.lastChapter,
          action.payload.lesson,
          action.payload.chapter,
        ),
      };
    }
    case TutorialActionTypes.SET_PLAYBACK_SPEED: {
      return {
        ...state,
        playbackSpeed: action.payload ?? state.playbackSpeed,
      };
    }
    case TutorialActionTypes.SET_MANUAL_PAUSE: {
      return {
        ...state,
        manualPause: action.payload.manualPause,
      };
    }
    default:
      return state;
  }
}
